module.exports = __webpack_public_path__ + "static/media/이영찬.9dc666f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/이영찬.png
// module id = 103
// module chunks = 0